import script from "./IngestPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./IngestPreview.vue?vue&type=script&setup=true&lang=js"

import "./IngestPreview.vue?vue&type=style&index=0&id=6dd26d9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dd26d9c"]])

export default __exports__